import {
    StyledImageWrapper,
    StyledNoDataBlock,
    StyledNoSelectedTopicDescription,
    StyledNoSelectedTopicHeader,
} from "app/pages/sales-intelligence/pages/manage-signals/components/NoDataTopics/styles";
import { AssetsService } from "app/services/AssetsService";
import { translate } from "app/filters/i18nFilter";

const NoDataTopics = () => {
    return (
        <StyledNoDataBlock>
            <StyledImageWrapper>
                <img
                    src={AssetsService.assetUrl("/images/intent/no_data_topics.svg")}
                    alt="No selected topics"
                />
            </StyledImageWrapper>
            <StyledNoSelectedTopicHeader>{translate("si.intent.management.no-data.title")}</StyledNoSelectedTopicHeader>
            <StyledNoSelectedTopicDescription>
                {translate("si.intent.management.no-data.description")}
            </StyledNoSelectedTopicDescription>
        </StyledNoDataBlock>
    );
};

export default NoDataTopics;
